import React from 'react';

/**
 * Consistent pagination controls used throughout the app.
 * Shows: « ‹ Page X of Y › » with optional "Showing X-Y of Z" summary.
 */
const PaginationControls = ({ currentPage, totalPages, onPageChange, totalItems, pageSize, itemLabel, className = '' }) => {
    if (totalPages <= 1) return null;

    const showingStart = totalItems ? ((currentPage - 1) * pageSize) + 1 : null;
    const showingEnd = totalItems ? Math.min(currentPage * pageSize, totalItems) : null;

    return (
        <div className={`flex justify-center items-center space-x-2 py-4 ${className}`}>
            {totalItems != null && pageSize && (
                <span className="text-sm text-gray-500 mr-4">
                    Showing {showingStart}-{showingEnd} of {totalItems}{itemLabel ? ` ${itemLabel}` : ''}
                </span>
            )}
            <button
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
                title="First page"
            >
                «
            </button>
            <button
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                title="Previous page"
            >
                ‹
            </button>
            <span className="text-sm text-gray-700">Page {currentPage} of {totalPages}</span>
            <button
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                title="Next page"
            >
                ›
            </button>
            <button
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
                title="Last page"
            >
                »
            </button>
        </div>
    );
};

export default PaginationControls;
